import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const authBaseEndpoint = ENDPOINTS.AUTH;
const method = METHODS.POST;

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}admin-login`,
        method,
        body: credentials,
      }),
    }),

    resetPasswordRequestApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}password-reset-request`,
        method: "POST",
        body: credentials,
      }),
    }),

    resetPasswordApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}reset-password`,
        method,
        body: credentials,
      }),
    }),

    validateOtpApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}validate-otp`,
        method,
        body: {
          emailOrHRTag: credentials.email,
          token: credentials.token,
        },
      }),
    }),

    changePasswordApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}change-password`,
        method,
        body: credentials,
      }),
    }),

    refreshTokenApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}refreshToken`,
        method,
        body: credentials,
      }),
    }),

    logoutApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}logout`,
        method,
        body: credentials,
      }),
    }),
    accountActivation: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}account-activation`,
        method,
        body: credentials,
      }),
    }),
  }),
});

// Export hooks for usage in components
export const {
  useLoginApiMutation,
  useResetPasswordApiMutation,
  useResetPasswordRequestApiMutation,
  useValidateOtpApiMutation,
  useChangePasswordApiMutation,
  useLogoutApiMutation,
  useRefreshTokenApiMutation,
  useAccountActivationMutation,
} = authApiSlice;
